 import React, { useState, useEffect} from 'react';

export default function ApyCalculator({burnBalance, stakingBalance, selfBalance, lpBalance, staked, ptgcPrice}) {
  const [holding, setHolding] = useState('');
  const [staking, setStaking] = useState('');
  const [volume, setVolume] = useState('');
  const [timespan, setTimeSpan] = useState(1);
  const [showResult, setShowResult] = useState(false);
  const [reward, setReward] = useState(0);
  const reflectionBalance = 333333333333 - (burnBalance + stakingBalance + selfBalance + lpBalance);

  useEffect(() => {
    setShowResult(false);
  }, [holding, staking, volume]);

  const calculateReward = async () => {
    const stakingFee = volume * 0.01;
    const reflectionFee = volume * 0.01;
    
    let reward = 0;

    if(staking > 0)
    {
      const rewardPerStaking = stakingFee / staked;
            reward += (rewardPerStaking * staking);
    }

    if(holding > 0) 
    {
      const rewardPerHolding = reflectionFee / reflectionBalance;
            reward += (rewardPerHolding * holding);
    }
    setReward(reward);
    setShowResult(true);
  };

  const calculateAPY = () => {
    const principal = parseFloat(holding) * (ptgcPrice);
    if (principal <= 0 || reward <= 0) return 0;

    const dailyRate = reward / principal;
    return dailyRate * 365 * 100;
  };

  useEffect(() => {
    if(staking > holding)
    {
      setStaking(holding);
    }
  }, [holding]);

  const [currency, setCurrency] = useState("PTGC");
  const handleCurrencyChange = (type) => {
    setCurrency(type);
    setVolume(""); 
  };
  return (
    <div className="container statsALL">
      <div className=" bSRIN overHide subcontent" >
        <div className="snPortal ">
          <div className="SRTOP d-flex flex-wrap justify-content-between align-items-center">
            <h2 className="mb-0">Reward Calculator</h2>
            <div className="iconSR">
              <img src="./images/MathOperations.svg" className="img-fluid" alt="icon" />
            </div>
          </div>
        </div>
        <div className="row m-0 ">
          <div className="col-md-12 col-xl-12 p-0 CalculatorTop ">
            <div className="">
              <div className="row m-0 borderBottom ">
                  <div className="col-md-6  col-xl-6 p-0 borderBottom borderRight">
                    <div className="boxes2">
                    <label className="fInter mb-1" htmlFor="burnTodayRange">Holding Amount</label>
                    <div className="amountSTaking  inputBGCOin d-flex justify-content-between align-items-center gap-3">
                      <div className="d-flex gap-2 w-100">
                      <img className="img-fluid" src="./images/ptgccircle.svg" style={{width:'30px'}} />
                      <input
                        type="text"
                        className="nobginput p-0 w-100"
                        placeholder="0.00"
                        style={{ borderRadius: '0px', background: 'transparent', border: '0px', padding: '0px' }}
                        value={
                          holding === ""
                            ? ""
                            : Number(holding.toString().replace(/,/g, "")).toLocaleString("en-US", {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0
                              })
                        }
                        onChange={(e) => {
                          const raw = e.target.value.replace(/,/g, "");
                          if (raw === "") {
                            setHolding("");
                            return;
                          }
                          if (isNaN(raw)) return;
                          const num = Math.min(Number(raw), Number(reflectionBalance));
                          setHolding(num.toString());
                        }}
                      />
                    </div>
                  </div>
                  </div>
                </div>
                  <div className="col-md-6  col-xl-6 p-0 borderBottom borderRight">
                    <div className="boxes2">
                    <label className="fInter mb-1" htmlFor="burnTodayRange">Staking Amount</label>
                    <div className="amountSTaking  inputBGCOin d-flex justify-content-between align-items-center gap-3">
                      <div className="d-flex gap-2 w-100">
                        <img className="img-fluid" src="./images/ptgccircle.svg" style={{width:'30px'}} />
                        <input
                          type="text"
                          className="nobginput p-0 w-100"
                          placeholder="0.00"
                          style={{ borderRadius: '0px', background: 'transparent', border: '0px', padding: '0px' }}
                          value={
                            staking === ""
                              ? ""
                              : Number(staking.toString().replace(/,/g, "")).toLocaleString("en-US", {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0
                                })
                          }
                          onChange={(e) => {
                            const raw = e.target.value.replace(/,/g, "");
                            if (raw === "") {
                              setStaking("");
                              return;
                            }
                            if (isNaN(raw)) return;
                            const num = Math.min(Number(raw), Number(holding));
                            setStaking(num.toString());
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                  <div className="col-md-6  col-xl-6 p-0  borderRight">
                    <div className="boxes2">
                    <label className="fInter mb-1" htmlFor="burnTodayRange">
                      Enter Daily Volume ({currency})
                    </label>
                    <div className="amountSTaking inputBGCOin d-flex justify-content-between align-items-center gap-3">
                      <div className="d-flex gap-2 w-100">
                      {currency === "PTGC" ? (
                          <img
                            src="./images/ptgccircle.svg"
                            className="img-fluid"
                            alt="icon"
                             style={{width:'auto', height: '30px'}}
                          />
                        ) : (
                          <img
                            src="./coinimages/0x15d38573d2feeb82e7ad5187ab8c1d52810b1f07.png"
                            className="img-fluid"
                            alt="icon"
                             style={{width:'auto', height: '30px', filter: 'grayscale(1)'}}
                          />
                        )}
                      <input
                        type="text"
                        className="nobginput p-0 w-100"
                        placeholder="0.00"
                        style={{
                          borderRadius: '0px',
                          background: 'transparent',
                          border: '0px',
                          padding: '0px'
                        }}
                        value={
                          volume === ""
                            ? ""
                            : Number(volume.toString().replace(/,/g, "")).toLocaleString("en-US", {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0
                              })
                        }
                        onChange={(e) => {
                          const raw = e.target.value.replace(/,/g, "");
                          if (raw === "" || !isNaN(raw)) {
                            setVolume(raw);
                          }
                        }}
                      />
                    </div>
                    {
                      /*
                      <div className="d-flex gap-1">
                        <button style={{marginBottom:'0px'}} 
                          className={`spanSpecial ${currency === "PTGC" ? "active" : ""}`}
                          onClick={() => handleCurrencyChange("PTGC")}
                        >
                          PTGC
                        </button>

                        <button style={{marginBottom:'0px'}} 
                          className={`spanSpecial ${currency === "USD" ? "active" : ""}`}
                          onClick={() => handleCurrencyChange("USD")}
                        >
                          USD
                        </button>
                      </div>
                      */
                    }
                  </div>
                  </div>
                </div>
                <div className="col-md-6 col-xl-6 p-0  borderRight">
                  <div className="boxes2">
                    <div className="d-flex gap-2 flex-wrap align-items-center">
                    <label className="fInter mb-1" htmlFor="burnTodayRange">Select Time Span</label>
                    <select style={{background: "rgb(0 0 0 / 33%)", padding: "10px", width: "100%",}} onChange={(e) => setTimeSpan(e.target.value)}>
                      <option value="1">Daily</option>
                      <option value="7">Weekly</option>
                      <option value="30">Monthly</option>
                      <option value="365">1 Year</option>
                      <option value="1825">5 Years</option>
                      <option value="3650">10 Years</option>
                    </select>
                  </div>
                  </div>
                </div>
              </div>
              <div className="p-2">
                {
                   (holding > 0 || staking > 0) && volume > 0 ?
                   <>
                    <button  className=" borderbtn mybtn w-100 d-flex justify-content-between align-items-center m-0" onClick={() => calculateReward()}>
                      <span>Calculate</span><span className="iconiconSR"><img className="img-fluid m-0" src="./images/Scales.svg"/></span>
                    </button>
                   </>
                   :
                   <>
                    <button className=" borderbtn mybtn w-100 d-flex justify-content-between align-items-center m-0" disabled>
                      <span>Calculate</span><span className="iconiconSR"><img className="img-fluid m-0" src="./images/Scales.svg"/></span>
                    </button>
                   </>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      {
        showResult ?
        <>
         <div className="statsALL">
            <div className="bSRIN overHide subcontent  mt-4">
              <div className="snPortal">
                <div className="SRTOP d-flex flex-wrap justify-content-between align-items-center">
                  <h2 className="mb-0">Result </h2>
                  <div className="iconSR">
                    <img className="img-fluid" src="./images/Coins.svg" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-xl-12 p-0  ">
                  <div className=" ">
                    <div className="row m-0">
                      <div className="col-xl-6 col-lg-6  borderRight p-0">
                        <div className="snPortal" style={{ padding: "26px 20px" }}>
                          <div className="">
                            <span className="fInter">Reward</span>
                            <h3 className="dollorValue value mt-0">
                              <span className="dollor">$</span>
                              <span>{parseFloat(reward * timespan).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                            </h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6 col-lg-6 p-0">
                        <div className="snPortal" style={{ padding: "26px 20px" }}>
                          <div className="">
                            <span className="fInter">APY</span>
                            <h3 className="dollorValue value mt-0">
                              <span className="val">{calculateAPY().toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 6 })}%</span>
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
        :
        <>
        </>
      }
    </div>
  );
}
